import Vue from 'vue'
import Vuex from 'vuex'
import Typing from './modules/Typing/index'
import TypingAdvanced from './modules/Typing/TypingAdvanced/index'
import TypingEssay from './modules/Typing/TypingEssay/index'
import TypingHistory from './modules/Typing/TypingHistory/index'
import Glossary from './modules/Vocabulary/Glossary/index'
import Exam from './modules/Vocabulary/Exam/index'
import VocabularyPractice from './modules/Vocabulary/Practice/index'
import VocabularyHistory from './modules/Vocabulary/History/index'
import Auth from './modules/Auth/index'
import Resource from './modules/Resource/index'
import StudyOrBreak from './modules/StudyOrBreak'
import OSSUtil from './modules/OSSUtil'
import Statistic from './modules/Statistic/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    typing: Typing,
    typingAdvanced: TypingAdvanced,
    typingEssay: TypingEssay,
    typingHistory: TypingHistory,
    glossary: Glossary,
    exam: Exam,
    vocabularyPractice: VocabularyPractice,
    vocabularyHistory: VocabularyHistory,
    auth: Auth,
    studyOrBreak: StudyOrBreak,
    resource: Resource,
    ossUtil: OSSUtil,
    statistic: Statistic
  },
  strict: process.env.NODE_ENV !== 'production'
})
